import RouterPaths from './RouterPaths';

export const InformationForUsersList = {
  contactUs: {
    label: 'Contact Us',
    path: RouterPaths.CONTACT_US,
  },
  privacyPolicy: {
    label: 'Privacy Policy',
    path: RouterPaths.PRIVACY_POLICY,
  },
  termsAndConditions: {
    label: 'Terms and Conditions',
    path: RouterPaths.TERMS_AND_CONDITIONS,
  },
  cookiePolicy: {
    label: 'Cookie Policy',
    path: RouterPaths.COOKIE_POLICY,
  },
  buyers: {
    label: 'Buyers',
    path: RouterPaths.HOMEPAGE,
  },
  sellers: {
    label: 'Sellers',
    path: RouterPaths.HOMEPAGE,
  },
  feesInformation: {
    label: 'Fee Information',
    path: RouterPaths.FEES_INFORMATION,
  },
  nextGearCapital: {
    label: 'NextGear Capital',
    path: RouterPaths.NEXT_GEAR_CAPITAL,
  },
};
